'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveLocation = exports.loadSavedLocation = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _updateSettings = require('../../helpers/updateSettings');

var _updateSettings2 = _interopRequireDefault(_updateSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadSavedLocation = exports.loadSavedLocation = function loadSavedLocation(navigationSettings, savedLocationType) {
  return navigationSettings && navigationSettings[savedLocationType] || _reactCookie2.default.load('navigation.' + savedLocationType, { path: '/', domain: '.surfline.com' });
};

var saveLocation = exports.saveLocation = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(taxonomyId, savedLocationType, loggedIn, navigationSettings, serviceConfig) {
    var settings;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!loggedIn) {
              _context.next = 6;
              break;
            }

            settings = {
              navigation: (0, _extends4.default)({}, navigationSettings, (0, _defineProperty3.default)({}, savedLocationType, taxonomyId))
            };
            _context.next = 4;
            return (0, _updateSettings2.default)(settings, serviceConfig);

          case 4:
            _context.next = 7;
            break;

          case 6:
            _reactCookie2.default.save('navigation.' + savedLocationType, taxonomyId, { path: '/', domain: '.surfline.com' });

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function saveLocation(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/utils/locationStore.js
// module id = 687
// module chunks = 11